var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeepinPhpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 336 416",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 186.93,
    x2: 186.93,
    y2: 373.87,
    gradientTransform: "scale(.89872 1.1127)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5672BD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314192",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m336 380c0 19.882-16.118 36-36 36h-264c-19.882 0-36-16.118-36-36v-344c0-19.882 16.118-36 36-36h196l104 104z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    y: -0.080769,
    height: 1.1808
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.149534536   0 0 0 0 0.271816956   0 0 0 0 0.918166893  0 0 0 0.2 0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 284,
    x2: 240.31,
    y1: 52,
    y2: 92.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.1,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.3,
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m232 0 104 104h-68c-19.882 0-36-16.118-36-36z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: -0.32308,
    y: -0.32308,
    width: 1.6462,
    height: 1.7231
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.79343 0 0 .79343 -35.118 -.63904)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(88,56)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000000",
    filter: "url(#f)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#e)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000000",
    filter: "url(#d)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#c)",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m216.67 311.76 16.734-85.765h19.871l-4.1835 22.235h18.826c16.734 1.0588 23.009 9.5294 20.917 20.118l-7.3211 43.412h-20.917l7.3211-39.176c1.0459-5.2941 1.0459-8.4706-6.2752-8.4706h-15.688l-9.4128 47.647zm-84.262 22.235 16.734-85.765h38.697c16.734 1.0588 25.101 9.5294 25.101 24.353 0 25.412-19.871 40.235-37.651 39.176h-18.826l-4.1835 22.235h-19.871zm28.238-38.118 5.2293-31.765h13.596c7.3211 0 12.55 3.1765 12.55 9.5294-1.0459 18-9.4128 21.176-18.826 22.235zm131.92 38.118 16.734-85.765h38.697c16.734 1.0588 25.101 9.5294 25.101 24.353 0 25.412-19.871 40.235-37.651 39.176h-18.826l-4.1835 22.235h-19.871zm28.238-38.118 5.2293-31.765h13.596c7.3211 0 12.55 3.1765 12.55 9.5294-1.0459 18-9.4128 21.176-18.826 22.235z",
    fill: "#fff",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeepinPhpIcon);
export default __webpack_public_path__ + "static/media/deepin-php-icon.d66846d1d1d74f165fc4e37c64d4386e.svg";
export { ForwardRef as ReactComponent };